import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  SET_FILE,
  SET_FILE_SUCCEEDED,
  SET_FILE_FAILED,
  LOAD_UPLOADED_FILES,
} from "../../common/constants";

import * as api from "../../services/fileUpload";
import Session from "../../utility/session";
function* fileUpload(action) {
  // console.log(action);
  try {
    const fileUploadResponse = yield call(api.fileUpload, action.file);
    // console.log("File upload response : " + JSON.stringify(fileUploadResponse));
    if (!fileUploadResponse.success) alert(fileUploadResponse.msg);
    yield put({ type: SET_FILE_SUCCEEDED, file: fileUploadResponse });
    yield put({
      type: LOAD_UPLOADED_FILES,
      userdata: {
        username: Session.getItem("current_username"),
        skip: 0,
        limit: 10,
        initial: true,
        uploadedResults: action.userData.uploadedResults,
      },
    });
  } catch (e) {
    //yield put({type:SET_FILE_FAILED,message:e.message});
  }
}

function* fileUploadSaga() {
  yield takeLatest(SET_FILE, fileUpload);
}

export default fileUploadSaga;



// WEBPACK FOOTER //
// ./src/Containers/BulkValidation/sagas.js